let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6g12u")).then(() => parcelRequire('8zEOf'));